import React from 'react';
import PropTypes, { object } from 'prop-types';
import {
  AreaChart,
  Area,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

import { colorsNew, tick } from '../helpers/config';
import CustomTooltip from './CustomTooltip/CustomTooltip';

const AreaFA = ({ chartData, show = false }) => {
  const names = Object.keys(chartData[0]).slice(1);
  const length = names.length;
  const reverseColors = colorsNew.slice(0, length).reverse();

  const formatter = value => (value ? `${value}%` : 0);

  return (
    <ResponsiveContainer width="100%" height={296}>
      <AreaChart
        data={chartData}
        margin={{
          top: 12,
          right: 0,
          left: -24,
          bottom: 0
        }}
      >
        <CartesianGrid vertical={false} stroke="#dde6f2" />
        <XAxis
          dataKey="week"
          tick={tick}
          axisLine={false}
          tickLine={false}
          padding={{ left: 32, right: 32 }}
        />
        <YAxis
          tickCount={10}
          scale="linear"
          domain={[
            0,
            dataMax =>
              dataMax
                ? Math.ceil(dataMax * 1.1) +
                  +(5 - (Math.ceil(dataMax * 1.1) % 5))
                : 100
          ]}
          tick={tick}
          axisLine={false}
          tickLine={false}
          tickFormatter={formatter}
        />
        {show && <Tooltip content={<CustomTooltip />} />}

        {names.reverse().map((area, ind) => {
          return (
            <Area
              key={area}
              type="monotone"
              dataKey={area}
              stroke={reverseColors[ind]}
              strokeWidth={2}
              fill={reverseColors[ind]}
              fillOpacity={0.5}
            />
          );
        })}
      </AreaChart>
    </ResponsiveContainer>
  );
};

AreaFA.propTypes = {
  chartData: PropTypes.arrayOf(object),
  show: PropTypes.bool
};

export default AreaFA;
